import { automationRuleActionsTitlesLocaleKeys } from './constants/loco-keys'
import { ActionSaveType } from 'src/editor/shared/types/automation-rules/actions-types'
import React from 'react'
import { getAutomationRuleActionIdAndLabel } from './utils/get-automation-rule-action-id-and-label'
import { getActionIcon } from './utils/get-action-icon'
import { SettingsMenuButtonWithIcon } from 'src/editor/shared/components/settings-menu-buttons/settings-menu-button-with-icon'
import { ActionIdType } from 'src/editor/shared/types/automation-rules/actions-types'

interface FullAddedActionsListProps {
  actions: ActionSaveType[]
  onOpenEditAction: (id: ActionIdType) => void
}

export const FullAddedActionsList = ({
  actions,
  onOpenEditAction,
}: FullAddedActionsListProps) => {
  return (
    <div className="flex flex-col gap-4">
      {actions.map(action => {
        const { id, label } = getAutomationRuleActionIdAndLabel(action) || {}
        return (
          <SettingsMenuButtonWithIcon
            key={id}
            title={automationRuleActionsTitlesLocaleKeys[action.type]}
            subtitle={label}
            iconBefore={() => getActionIcon(action.type)}
            onClick={() => {
              onOpenEditAction(action.id)
            }}
          />
        )
      })}
    </div>
  )
}
